import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';
import { SelectItem } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { KontableComponent } from './../../../../modules/UIKit/components/kontable/kontable.component';
import { PromotionCatalogGiftService } from './../../../../services/promotion/promotion-catalog-gift.service';
import { Component, OnInit } from '@angular/core';
import { LoyaltyCatalogCategoryService } from 'app/services/loyalty/loyalty-catalog-category.service';


@Component({
  selector: 'app-catalog-gift',
  templateUrl: './catalog-gift.component.html',
  styleUrls: ['./catalog-gift.component.css']
})
export class CatalogGiftComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  selectFilter = KontableComponent.SelectFilter;
  catalogName: string;
  catalogId: number;
  categoryGiftDesc: SelectItem[] = [];
  giftTypes: SelectItem[] = [];
  reservationTypes: SelectItem[] = [];
  deliveryTypes: SelectItem[] = [];
  flgReserved: SelectItem[] = [];
  newDataAvailable = false;

  constructor(
    public catalogGiftService: PromotionCatalogGiftService,
    public loyaltyCatalogGiftService: LoyaltyCatalogCategoryService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.catalogName = this.activatedRoute.snapshot.paramMap.get('catalogName');
    sessionStorage.setItem('catalogName', this.catalogName);
    this.catalogId = this.activatedRoute.snapshot.params['catalogId'];
    this.catalogGiftService.getCatalogId(this.catalogId);

  }

  ngOnInit() {
    this.catalogName = sessionStorage.getItem('catalogName');
    const translateObs = this.translateService.get([
      'common.all',
      'common.yes',
      'common.no'
    ]);

    const obCategoryGift: Observable<any> = this.loyaltyCatalogGiftService.getCategoryGifts();
    const obGiftType: Observable<any> = this.catalogGiftService.getCatalogGiftTypes();
    const obReservationType: Observable<any> = this.catalogGiftService.getParamTypes('reservation_type');
    const obDeliveryType: Observable<any> = this.catalogGiftService.getParamTypes('delivery_type');

    Observable.zip(
      translateObs,
      obCategoryGift,
      obGiftType,
      obReservationType,
      obDeliveryType,
    ).subscribe(([
      resTranslate,
      resCategoryGift,
      resGiftType,
      resReservationType,
      resDeliveryType,
    ]) => {
      // Popolo dropdown Tipologia Premio
      this.categoryGiftDesc.push({label: resTranslate['common.all'], value: null});
      resCategoryGift.forEach(categoryGift => this.categoryGiftDesc.push({value: categoryGift.description, label: categoryGift.description}));
      // Popolo dropdown Tipologia Premio
      this.giftTypes.push({label: resTranslate['common.all'], value: null});
      resGiftType.forEach(giftType => this.giftTypes.push({value: giftType.description, label: giftType.description}));
      // Popolo dropdown Tipologia Prenotazione
      this.reservationTypes.push({label: resTranslate['common.all'], value: null});
      resReservationType.forEach(resType => this.reservationTypes.push({value: resType.description, label: resType.description}));
      // Popolo dropdown Tipologia Consegna
      this.deliveryTypes.push({label: resTranslate['common.all'], value: null});
      resDeliveryType.forEach(delType => this.deliveryTypes.push({value: delType.description, label: delType.description}));
      this.flgReserved.push({label: resTranslate['common.all'], value: null});
      this.flgReserved.push({label: resTranslate['common.yes'], value: '0'});
      this.flgReserved.push({label: resTranslate['common.no'], value: '1'});
    });

  }

  editGift(giftId: number) {
    this.router.navigate([`promotion/catalog/${this.catalogId}/gift/detail/${giftId}`]);
  }

  addGift() {
    this.router.navigate([`promotion/catalog/${this.catalogId}/gift/detail`]);
  }

  deleteCatalogGift(id: number, table) {
    this.catalogGiftService.deleteCatalogGift(id).subscribe(() => table.refresh());
  }

  recoverCatalogGift(gift) {
    this.catalogGiftService.recoverCatalogGift(gift).subscribe(() => this.newDataAvailable = true);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog-gift/catalog-gift.component.ts